
import { Component, Prop, Vue } from "vue-property-decorator";
import Button from "@/components/Button.vue";


@Component({
  components: {
    Button
  }
})
export default class Contact extends Vue {
}
